function Home() {
  return (
    <section>Home</section>
  )
}

export default Home